var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('spinner-until',{attrs:{"condition":_vm.surveyId != null}},[_c('div',{staticClass:"survey-create"},[(_vm.surveyId)?_c('survey-form',{attrs:{"survey-id":_vm.surveyId}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }